import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=b2f94fdc&scoped=true"
import script from "./RuleForm.vue?vue&type=script&lang=js"
export * from "./RuleForm.vue?vue&type=script&lang=js"
import style0 from "./RuleForm.vue?vue&type=style&index=0&id=b2f94fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f94fdc",
  null
  
)

export default component.exports